import {useEffect, useState} from 'react'
import Loader from '../../custom/loader/Loader'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../redux/hooks'
import {Link} from 'react-router-dom'
import {useAuth} from 'app/modules/auth'
import LecStatistics from './LecturerStatistics'
import StdStatistics from './StdStatistics'
import FinanceDashboard from './FinanceDashboard'
import {StudentCounts} from '../../../redux/Slice/studentSlice'
import EvaluationDashboard from './EvaluationDashboard'

const AdminDashboard = () => {
  const [loader, setLoader] = useState(true)
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {hasPermission} = useAuth()
  const [studentCounts, setStudentCounts] = useState<any>(null)
  const [showLecturerCharts, setShowLecturerCharts] = useState(false)
  const [showStudentCharts, setShowStudentCharts] = useState(false)
  const [showEvaluationCharts, setShowEvaluationCharts] = useState(false)
  const [showPaymentCharts, setShowPaymentCharts] = useState(false)

  useEffect(() => {
    dispatch(StudentCounts()).then((res: any) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setStudentCounts(res.payload)
        setLoader(false)
      }
    })
  }, [])

  if (loader) return <Loader />

  return (
    <div className='container-fluid px-4'>
      {/* Student Statistics Cards */}
      {studentCounts && (
        <div className='row g-4'>
          {/* Applications Card */}
          <div className='col-md-4'>
            <Link
              to={
                hasPermission('student-applications-list')
                  ? '/student/student-applications-list'
                  : '#'
              }
              className='text-decoration-none'
            >
              <div className='card bg-primary text-white shadow rounded-4'>
                <div className='card-body d-flex align-items-center p-3'>
                  <i className='fas fa-file-alt mx-4' style={{fontSize: '3rem'}}></i>
                  <div>
                    <div className='fs-1 fw-bold'>{studentCounts.apps}</div>
                    <div className='fs-3'>{t('DASHBOARD.TOTAL_APPLICATIONS')}</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Students Card */}
          <div className='col-md-4'>
            <Link
              to={hasPermission('students-list') ? '/student/students-list' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-success text-white shadow rounded-4'>
                <div className='card-body d-flex align-items-center p-3'>
                  <i className='fas fa-user-graduate mx-4' style={{fontSize: '3rem'}}></i>
                  <div>
                    <div className='fs-1 fw-bold'>{studentCounts.students}</div>
                    <div className='fs-3'>{t('DASHBOARD.TOTAL_STUDENTS')}</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Alumni Card */}
          <div className='col-md-4'>
            <Link
              to={
                hasPermission('student-applications-list') ? '/student/alumni-students-list' : '#'
              }
              className='text-decoration-none'
            >
              <div className='card bg-info text-white shadow rounded-4'>
                <div className='card-body d-flex align-items-center p-3'>
                  <i className='fas fa-user-tie mx-4' style={{fontSize: '3rem'}}></i>
                  <div>
                    <div className='fs-1 fw-bold'>{studentCounts.alumnies}</div>
                    <div className='fs-3'>{t('DASHBOARD.TOTAL_ALUMNI')}</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Teaching Staff Card */}
          <div className='col-md-4'>
            <Link
              to={hasPermission('lecturers-list') ? '/admin/lecturers-list' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-primary-subtle text-white shadow  rounded-4'>
                <div className='card-body d-flex align-items-center p-3'>
                  <i className='fas fa-chalkboard-teacher mx-4' style={{fontSize: '3rem'}}></i>
                  <div>
                    <div className='fs-1 fw-bold text-dark'>{studentCounts.lecturers}</div>
                    <div className='fs-3 text-dark'>{t('MENU.LECTURERS')}</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          {/* Non Teaching Staff Card */}
          <div className='col-md-4'>
            <Link
              to={hasPermission('staff-list') ? '/admin/staffs' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-warning text-white shadow rounded-4'>
                <div className='card-body d-flex align-items-center p-3'>
                  <i className='fas fa-user-cog mx-4' style={{fontSize: '3rem'}}></i>
                  <div>
                    <div className='fs-1 fw-bold'>{studentCounts.staff}</div>
                    <div className='fs-3'>{t('MENU.NON_STAFF')}</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          {/* Lecturer Contracts */}
          <div className='col-md-4'>
            <Link
              to={hasPermission('lecturer-contracts-list') ? '/admin/lecturer-contracts' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-danger text-white shadow rounded-4'>
                <div className='card-body d-flex align-items-center p-3'>
                  <i
                    className='fas fa-file-signature mx-4 text-white'
                    style={{fontSize: '3rem'}}
                  ></i>
                  <div>
                    <div className='fs-1 fw-bold'>{studentCounts.contracts}</div>
                    <div className='fs-3'>{t('MENU.LECTURER_CONTRACTS')}</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      )}

      {/* <FinanceDashboard /> */}
      {hasPermission('finance-dashboard-view') && (
        <div className='card shadow-sm h-100 mt-5'>
          <div
            className='card-header bg-primary'
            style={{minHeight: '30px'}}
            onClick={() => setShowPaymentCharts(!showPaymentCharts)}
          >
            <h3 className='text-white mt-3'>{t('DASHBOARD.FINANCIAL_OVERVIEW')}</h3>
            <button type='button' className='btn btn-link btn-sm text-white'>
              <span className={`fa fa-caret-${showPaymentCharts ? 'down' : 'up'}`}></span>
            </button>
          </div>
          {showPaymentCharts && <FinanceDashboard />}
        </div>
      )}

      <div className='card shadow-sm h-100 mt-5'>
        <div
          className='card-header bg-primary'
          style={{minHeight: '30px'}}
          onClick={() => setShowLecturerCharts(!showLecturerCharts)}
        >
          <h3 className='text-white mt-3'>{t('DASHBOARD.PROFESSOR_OVERVIEW')}</h3>
          <button type='button' className='btn btn-link btn-sm text-white'>
            <span className={`fa fa-caret-${showLecturerCharts ? 'down' : 'up'}`}></span>
          </button>
        </div>
        {showLecturerCharts && (
          <div className='card-body'>
            <LecStatistics />
          </div>
        )}
      </div>

      <div className='card shadow-sm h-100 mt-5'>
        <div
          className='card-header bg-primary'
          style={{minHeight: '30px'}}
          onClick={() => setShowStudentCharts(!showStudentCharts)}
        >
          <h3 className='text-white mt-3'>{t('DASHBOARD.STUDENTS_PROFILE')}</h3>
          <button type='button' className='btn btn-link btn-sm text-white'>
            <span className={`fa fa-caret-${showStudentCharts ? 'down' : 'up'}`}></span>
          </button>
        </div>
        {showStudentCharts && (
          <div className='card-body'>
            <StdStatistics />
          </div>
        )}
      </div>

      <div className='card shadow-sm h-100 mt-5'>
        <div
          className='card-header bg-primary'
          style={{minHeight: '30px'}}
          onClick={() => setShowEvaluationCharts(!showEvaluationCharts)}
        >
          <h3 className='text-white mt-3'>{t('LABEL.FEEDBACK_AND_EVALUATION')}</h3>
          <button type='button' className='btn btn-link btn-sm text-white'>
            <span className={`fa fa-caret-${showEvaluationCharts ? 'down' : 'up'}`}></span>
          </button>
        </div>
        {showEvaluationCharts && <EvaluationDashboard />}
      </div>
    </div>
  )
}

export default AdminDashboard
